interface Scripts {
    name: string;
    src: string;
}  
export const ScriptStore: Scripts[] = [
    {name: 'movidesk', src: "https://chat.movidesk.com/Scripts/chat-widget.min.js"},
];